import { Component } from "@angular/core";
import { OrdersComponent } from "../../orders.component";

@Component({
  selector: "jni-inventory-sales-listing",
  templateUrl: "./inventory-sales-listing.component.html",
  styleUrls: ["./inventory-sales-listing.component.css"],
  imports: [OrdersComponent],
})
export class InventorySalesListingComponent {}
